var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-error",class:{ 'is-large': _vm.size === 'large' }},[(_vm.showIcon)?_c('el-icon',{staticClass:"form-error__icon",attrs:{"name":"i-times-circle--16"}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }